import AbstractNetworkStatus from '../all/AbstractNetworkStatus';
import logger from 'src/utils/logger/logger';

class LgNetworkStatus extends AbstractNetworkStatus {

  constructor() {
    super();
  }

  isOnline() {
    logger.debug('[NetworkStatus] checking LG...');
    return this.onlineByAjax();
  }

}

export default LgNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/lg/NetworkStatus.js